import React from "react";
import { Link, useLocation } from "react-router-dom";
import Paper from "@mui/material/Paper";
import "./SidebarFichesMetiers.css";

const autresFiches = [
  { path: "/fiches/consultant-cybersecurite", label: "Consultant Cybersécurité" },
  { path: "/fiches/chef-projet-agile", label: "Chef de Projet Agile" },
  { path: "/fiches/data-analyst", label: "Data Analyst" },
  { path: "/fiches/data-engineer", label: "Data Engineer" },
  { path: "/fiches/data-scientist", label: "Data Scientist" },
  { path: "/fiches/expert-machine-learning", label: "Expert Machine Learning" },
  { path: "/fiches/ingenieur-ia", label: "Ingénieur IA" },
  { path: "/fiches/ingenieur-big-data", label: "Ingénieur Big Data" },
  { path: "/fiches/ingenieur-devops", label: "Ingénieur DevOps" },
  { path: "/fiches/cloud", label: "Ingénieur Cloud" },
];

const dynamicMessages = {
  "/fiches/consultant-cybersecurite": "pour recruter un Consultant Cybersécurité et renforcer la sécurité de votre SI.",
  "/fiches/chef-projet-agile": "pour recruter un Chef de Projet Agile et piloter vos projets digitaux avec succès.",
  "/fiches/data-analyst": "pour recruter un Data Analyst et valoriser vos données.",
  "/fiches/data-engineer": "pour recruter un Data Engineer et structurer votre architecture data.",
  "/fiches/data-scientist": "pour recruter un Data Scientist et booster vos analyses avancées.",
  "/fiches/expert-machine-learning": "pour recruter un Expert en Machine Learning et passer à la vitesse supérieure en IA.",
  "/fiches/ingenieur-ia": "pour recruter un Ingénieur IA et développer vos solutions d'intelligence artificielle.",
  "/fiches/ingenieur-big-data": "pour recruter un Ingénieur Big Data et exploiter le plein potentiel de vos données.",
  "/fiches/ingenieur-devops": "pour recruter un Ingénieur DevOps et fluidifier vos déploiements applicatifs.",
  "/fiches/cloud": "pour recruter un Ingénieur Cloud et réussir votre transition vers le cloud.",
  "/fiches/developpeur-backend": "pour recruter un Développeur Back-End et renforcer votre architecture applicative.",
  "/fiches/developpeur-frontend": "pour recruter un Développeur Front-End et offrir une expérience utilisateur optimale.",
  "/fiches/developpeur-fullstack": "pour recruter un Développeur Full-Stack et accélérer vos développements.",
  "/fiches/developpeur-mobile": "pour recruter un Développeur Mobile et toucher vos clients sur tous les devices.",
  "/fiches/ui-ux-designer": "pour recruter un UI/UX Designer et améliorer l’expérience de vos utilisateurs.",
  "/fiches/scrum-master": "pour recruter un Scrum Master et dynamiser vos équipes agiles.",
  "/fiches/testeur-qa": "pour recruter un Testeur QA et garantir la qualité de vos applications."
};

const SidebarFichesMetiers = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const message = dynamicMessages[currentPath] ||
    "pour recruter les meilleurs talents IT et accélérer vos projets.";

  return (
    <div>
      <Paper elevation={0} className="sidebar-fiches-card sidebar-fiches-maincards">
        <div className="sidebar-title">Nos autres fiches métiers</div>
        <ul className="sidebar-list">
          {autresFiches.map(fiche =>
            <li key={fiche.path} className={fiche.path === currentPath ? "current" : ""}>
              <Link to={fiche.path} className="sidebar-link">
                &rsaquo; {fiche.label} <span className="chevron"></span>
              </Link>
            </li>
          )}
        </ul>
        <div className="sidebar-all">
          <Link to="/fiches" className="sidebar-link all">
            <b>Voir toutes nos fiches</b> <span className="chevron"></span>
          </Link>
        </div>
      </Paper>
      {/* Card dynamique */}
      <Paper elevation={0} className="sidebar-fiches-card sidebar-fiches-dynacard">
        <div className="sidebar-dynacard-title">
          Vous cherchez ce profil&nbsp;?
        </div>
        <div className="sidebar-dynacard-text">
          👉 Inscrivez-vous sur <b>COOPTALEO</b> {message}
        </div>
        <Link
          to="/signup/entreprise"
          className="btn-inscription-sidebar"
        >
          S'inscrire gratuitement
        </Link>
      </Paper>
    </div>
  );
};

export default SidebarFichesMetiers;
